const TimeIcon = () => {
	return (
		<svg focusable="false" height="20" width="20">
			<g fill-rule="evenodd" fill="none" transform="translate(0, 0) scale(1)">
				<path
					d="M15 1v1h4v14c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3V2h4V1h2v1h6V1h2zM4 17h12c.552 0 1-.449 1-1V9H3v7c0 .551.448 1 1 1zM5 4v1h2V4h6v1h2V4h2v3H3V4h2zm4 7v3H5v-3h4z"
					fill="rgba(14, 14, 15, 1)"
				></path>
			</g>
		</svg>
	);
};

export default TimeIcon;
